'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _tabs = require('antd/lib/tabs');

var _tabs2 = _interopRequireDefault(_tabs);

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _modal = require('antd/lib/modal');

var _modal2 = _interopRequireDefault(_modal);

var _spin = require('antd/lib/spin');

var _spin2 = _interopRequireDefault(_spin);

var _reactRedux = require('react-redux');

var _user = require('../actions/user');

var _row = require('antd/lib/grid/row');

var _row2 = _interopRequireDefault(_row);

var _col = require('antd/lib/grid/col');

var _col2 = _interopRequireDefault(_col);

var _requests = require('../actions/requests');

var _User = require('../models/User');

var _User2 = _interopRequireDefault(_User);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormItem = _form2.default.Item;
var TabPane = _tabs2.default.TabPane;

var EmailForm = function (_React$Component) {
    _inherits(EmailForm, _React$Component);

    function EmailForm() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, EmailForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EmailForm.__proto__ || Object.getPrototypeOf(EmailForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            confirmDirty: false
        }, _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.props.form.validateFields(function (err, values) {
                if (!err) {
                    _this.props.onValidated(values);
                }
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(EmailForm, [{
        key: 'render',
        value: function render() {
            var getFieldDecorator = this.props.form.getFieldDecorator;

            var formItemLayout = {
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 6 }
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 6 }
                }
            };
            var tailFormItemLayout = {
                wrapperCol: {
                    xs: {
                        span: 24,
                        offset: 0
                    },
                    sm: {
                        span: 6,
                        offset: 6
                    }
                }
            };

            return _react2.default.createElement(
                _form2.default,
                { onSubmit: this.handleSubmit },
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { label: '\u041D\u043E\u0432\u044B\u0439 E-mail', hasFeedback: true }),
                    getFieldDecorator('email', {
                        rules: [{
                            required: true, message: 'Введите e-mail!'
                        }]
                    })(_react2.default.createElement(_input2.default, { type: 'email' }))
                ),
                _react2.default.createElement(
                    FormItem,
                    tailFormItemLayout,
                    _react2.default.createElement(
                        _button2.default,
                        { type: 'primary', htmlType: 'submit', size: 'large' },
                        '\u0421\u043C\u0435\u043D\u0438\u0442\u044C E-mail'
                    )
                )
            );
        }
    }]);

    return EmailForm;
}(_react2.default.Component);

var WrappedEmailForm = _form2.default.create()((0, _reactRedux.connect)()(EmailForm));

var PasswordForm = function (_React$Component2) {
    _inherits(PasswordForm, _React$Component2);

    function PasswordForm() {
        var _ref2;

        var _temp2, _this2, _ret2;

        _classCallCheck(this, PasswordForm);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = PasswordForm.__proto__ || Object.getPrototypeOf(PasswordForm)).call.apply(_ref2, [this].concat(args))), _this2), _this2.state = {
            confirmDirty: false
        }, _this2.handleSubmit = function (e) {
            e.preventDefault();
            _this2.props.form.validateFields(function (err, values) {
                if (!err) {
                    _this2.props.onValidated(values);
                }
            });
        }, _this2.handleConfirmBlur = function (e) {
            var value = e.target.value;
            _this2.setState({ confirmDirty: _this2.state.confirmDirty || !!value });
        }, _this2.checkPassword = function (rule, value, callback) {
            var form = _this2.props.form;
            if (value && value !== form.getFieldValue('password')) {
                callback('Пароли не совпадают!');
            } else {
                callback();
            }
        }, _this2.checkConfirm = function (rule, value, callback) {
            var form = _this2.props.form;
            if (value && _this2.state.confirmDirty) {
                form.validateFields(['password_verify'], { force: true });
            }
            callback();
        }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    _createClass(PasswordForm, [{
        key: 'render',
        value: function render() {
            var getFieldDecorator = this.props.form.getFieldDecorator;

            var formItemLayout = {
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 6 }
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 6 }
                }
            };
            var tailFormItemLayout = {
                wrapperCol: {
                    xs: {
                        span: 24,
                        offset: 0
                    },
                    sm: {
                        span: 6,
                        offset: 6
                    }
                }
            };

            return _react2.default.createElement(
                _form2.default,
                { onSubmit: this.handleSubmit },
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { label: '\u0422\u0435\u043A\u0443\u0449\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C', hasFeedback: true }),
                    getFieldDecorator('password_current', {
                        rules: [{
                            required: true, message: 'Введите пароль!'
                        }]
                    })(_react2.default.createElement(_input2.default, { type: 'password' }))
                ),
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { label: '\u041D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C', hasFeedback: true }),
                    getFieldDecorator('password', {
                        rules: [{
                            required: true, message: 'Введите пароль!'
                        }, {
                            validator: this.checkConfirm
                        }]
                    })(_react2.default.createElement(_input2.default, { type: 'password' }))
                ),
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { label: '\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C', hasFeedback: true }),
                    getFieldDecorator('password_verify', {
                        rules: [{
                            required: true, message: 'Подтвердите пароль!'
                        }, {
                            validator: this.checkPassword
                        }]
                    })(_react2.default.createElement(_input2.default, { type: 'password', onBlur: this.handleConfirmBlur }))
                ),
                _react2.default.createElement(
                    FormItem,
                    tailFormItemLayout,
                    _react2.default.createElement(
                        _button2.default,
                        { type: 'primary', htmlType: 'submit', size: 'large' },
                        '\u0421\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C'
                    )
                )
            );
        }
    }]);

    return PasswordForm;
}(_react2.default.Component);

var WrappedPasswordForm = _form2.default.create()((0, _reactRedux.connect)()(PasswordForm));

var MainForm = function (_React$Component3) {
    _inherits(MainForm, _React$Component3);

    function MainForm() {
        var _ref3;

        var _temp3, _this3, _ret3;

        _classCallCheck(this, MainForm);

        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
        }

        return _ret3 = (_temp3 = (_this3 = _possibleConstructorReturn(this, (_ref3 = MainForm.__proto__ || Object.getPrototypeOf(MainForm)).call.apply(_ref3, [this].concat(args))), _this3), _this3.state = {
            confirmDirty: false
        }, _this3.handleSubmit = function (e) {
            e.preventDefault();
            _this3.props.form.validateFields(function (err, values) {
                if (!err) {
                    _this3.props.onValidated(values);
                }
            });
        }, _temp3), _possibleConstructorReturn(_this3, _ret3);
    }

    _createClass(MainForm, [{
        key: 'render',
        value: function render() {
            var getFieldDecorator = this.props.form.getFieldDecorator;

            var formItemLayout = {
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 6 }
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 6 }
                }
            };
            var tailFormItemLayout = {
                wrapperCol: {
                    xs: {
                        span: 24,
                        offset: 0
                    },
                    sm: {
                        span: 6,
                        offset: 6
                    }
                }
            };

            return _react2.default.createElement(
                _form2.default,
                { onSubmit: this.handleSubmit },
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { label: '\u0418\u043C\u044F', hasFeedback: true }),
                    getFieldDecorator('firstname', {
                        rules: [{
                            required: true, message: 'Введите ваше имя!'
                        }]
                    })(_react2.default.createElement(_input2.default, { type: 'text' }))
                ),
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { label: '\u0424\u0430\u043C\u0438\u043B\u0438\u044F', hasFeedback: true }),
                    getFieldDecorator('lastname', {
                        rules: [{
                            required: true, message: 'Введите фамилию!'
                        }]
                    })(_react2.default.createElement(_input2.default, { type: 'text' }))
                ),
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { label: '\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u043C\u043E\u0435 \u0438\u043C\u044F', hasFeedback: true }),
                    getFieldDecorator('displayname', {
                        rules: [{
                            required: false
                        }]
                    })(_react2.default.createElement(_input2.default, { type: 'text' }))
                ),
                _react2.default.createElement(
                    FormItem,
                    tailFormItemLayout,
                    _react2.default.createElement(
                        _button2.default,
                        { type: 'primary', htmlType: 'submit', size: 'large' },
                        '\u0421\u043C\u0435\u043D\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435'
                    )
                )
            );
        }
    }]);

    return MainForm;
}(_react2.default.Component);

var WrappedMainForm = _form2.default.create({
    mapPropsToFields: function mapPropsToFields(props) {
        return {
            firstname: { value: props.user.firstname },
            lastname: { value: props.user.lastname },
            displayname: { value: props.user.displayname }
        };
    }
})((0, _reactRedux.connect)()(MainForm));

var SecurityTab = function (_React$Component4) {
    _inherits(SecurityTab, _React$Component4);

    function SecurityTab() {
        var _ref4;

        var _temp4, _this4, _ret4;

        _classCallCheck(this, SecurityTab);

        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
        }

        return _ret4 = (_temp4 = (_this4 = _possibleConstructorReturn(this, (_ref4 = SecurityTab.__proto__ || Object.getPrototypeOf(SecurityTab)).call.apply(_ref4, [this].concat(args))), _this4), _this4.state = {
            changing: false
        }, _this4.onValidated = function (passwordData) {
            _this4.setState({ changing: true }, function () {
                _this4.props.dispatch((0, _user.changeUser)(passwordData, function (_ref5) {
                    var ok = _ref5.ok,
                        dispatch = _ref5.dispatch;

                    _this4.setState({ changing: false }, function () {
                        if (ok) {
                            _modal2.default.info({
                                title: 'Пароль изменен', onOk: function onOk() {
                                    dispatch((0, _user.logout)());
                                }
                            });
                        } else {
                            _message2.default.error('Пароль не изменен');
                        }
                    });
                }));
            });
        }, _this4.onValidatedEmail = function (emailData) {
            var _this4$props = _this4.props,
                user = _this4$props.user,
                config = _this4$props.config;

            var requestData = {
                id: _this4.props.user.id,
                email: emailData.email,
                result_url: window.location.href
            };

            // TODO: Move to Auth Class
            _this4.props.dispatch((0, _requests.postApi)(config.auth.OAUTHUrl + '/v/email_verification?lang=ru', _user.EMAIL_VERIFICATION, {
                data: requestData,
                headers: {
                    'Authorization': user.tokenType + ' ' + user.token
                }
            }));
        }, _temp4), _possibleConstructorReturn(_this4, _ret4);
    }

    _createClass(SecurityTab, [{
        key: 'render',
        value: function render() {
            var user = this.props.user;

            return _react2.default.createElement(
                _spin2.default,
                { spinning: this.state.changing },
                _react2.default.createElement('br', null),
                _react2.default.createElement(WrappedPasswordForm, { onValidated: this.onValidated }),
                _react2.default.createElement(
                    _row2.default,
                    { className: 'ant-form-item' },
                    _react2.default.createElement(
                        _col2.default,
                        { sm: 6, xs: 24, className: 'ant-form-item-label' },
                        _react2.default.createElement(
                            'label',
                            null,
                            '\u0422\u0435\u043A\u0443\u0449\u0438\u0439 E-mail'
                        )
                    ),
                    _react2.default.createElement(
                        _col2.default,
                        { sm: 6, xs: 24, style: { lineHeight: '32px' } },
                        _react2.default.createElement(
                            'strong',
                            null,
                            user.email || 'не задан'
                        )
                    )
                ),
                _react2.default.createElement(WrappedEmailForm, { onValidated: this.onValidatedEmail })
            );
        }
    }]);

    return SecurityTab;
}(_react2.default.Component);

var MainInfo = function (_React$Component5) {
    _inherits(MainInfo, _React$Component5);

    function MainInfo() {
        var _ref6;

        var _temp5, _this5, _ret5;

        _classCallCheck(this, MainInfo);

        for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            args[_key5] = arguments[_key5];
        }

        return _ret5 = (_temp5 = (_this5 = _possibleConstructorReturn(this, (_ref6 = MainInfo.__proto__ || Object.getPrototypeOf(MainInfo)).call.apply(_ref6, [this].concat(args))), _this5), _this5.state = {
            changing: false,
            user: new _User2.default(_this5.props.user)
        }, _this5.onValidated = function (newData) {
            _this5.state.user.extend(newData);
            _this5.setState({ changing: true }, function () {
                _this5.props.dispatch((0, _user.changeUser)(newData, function (_ref7) {
                    var ok = _ref7.ok,
                        dispatch = _ref7.dispatch;

                    _this5.setState({ changing: false }, function () {
                        if (ok) {
                            _message2.default.info('Сохранено');
                        } else {
                            _message2.default.error('Информация не сохранена');
                        }
                    });
                }));
            });
        }, _temp5), _possibleConstructorReturn(_this5, _ret5);
    }

    _createClass(MainInfo, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _spin2.default,
                { spinning: this.state.changing },
                _react2.default.createElement('br', null),
                _react2.default.createElement(WrappedMainForm, { onValidated: this.onValidated, user: this.state.user })
            );
        }
    }]);

    return MainInfo;
}(_react2.default.Component);

var SecurityTabWrapped = (0, _reactRedux.connect)(function (state) {
    return { user: state.user, config: state.config };
})(SecurityTab);
var MainInfoWrapped = (0, _reactRedux.connect)(function (state) {
    return { user: state.user };
})(MainInfo);

var ProfileSettings = function (_React$Component6) {
    _inherits(ProfileSettings, _React$Component6);

    function ProfileSettings() {
        _classCallCheck(this, ProfileSettings);

        return _possibleConstructorReturn(this, (ProfileSettings.__proto__ || Object.getPrototypeOf(ProfileSettings)).apply(this, arguments));
    }

    _createClass(ProfileSettings, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _tabs2.default,
                { defaultActiveKey: 'main' },
                _react2.default.createElement(
                    TabPane,
                    { tab: '\u041E\u0431\u0449\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F', key: 'main' },
                    _react2.default.createElement(MainInfoWrapped, null)
                ),
                _react2.default.createElement(
                    TabPane,
                    { tab: '\u0411\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C', key: 'security' },
                    _react2.default.createElement(SecurityTabWrapped, null)
                )
            );
        }
    }]);

    return ProfileSettings;
}(_react2.default.Component);

exports.default = ProfileSettings;
//# sourceMappingURL=ProfileSettings.js.map


//////////////////
// WEBPACK FOOTER
// ./~/perx-uikit/dist/containers/ProfileSettings.js
// module id = 1283
// module chunks = 5